<template>
	<div class='ai-intro'>
    <h2>人工智能平台介绍</h2>
    <div class="box">
      <img src="../assets/images/ai-introduce.png"/>
<!--					<video :src="data" height="100%" controls="controls"></video>-->
      <div class="content">MoPaaS 针对中国人工智能市场的需求打造了开放的人工智能平台。 该平台基于自主的云(PaaS)+AI技术架构，为人工智能模型训练和服务提供并行训练的算力优化，以及高效机器学习开发运维管理 (MLOps)。 特别是平台整合多种AI/机器学习框架，优化调度 GPU + 异构算力资源，弹性提供规模化分布式规模训练环境，全流程地支持 AI 模型的构建、训练、部署和服务运维。 MoPaaS人工智能平台产品可以通过私有部署和云服务的形式广泛地服务于教学科研、工业制造、能源交通、互联网、医疗卫生、政府和金融等行业；MoPaaS 致力打造全方位开放的智能云服务生态圈。 MoPaaS 被Forrester评为中国企业级云平台市场的卓越表现者（Strong Performer)。</div>
    </div>
	</div>
</template>

<script>
	export default {
		name: 'AiIntro'
	}
</script>

<style>
  @media (min-width:992px) {
    .ai-intro {
      background: #F5F6F9;
      padding: 120px 0;
    }

    .ai-intro h2 { 
      margin: 0 auto;
      width: 240px;
      height: 34px;
      font-size: 30px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 34px;
    }
    .ai-intro .box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 1400px;
      margin: 70px auto 0;
    }
    .ai-intro .box img {
      width: 835px;
      height: 488px;
    }
    .ai-intro .box .content {
      width: 518px;
      height: 488px;
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
      text-align: left;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/AiIntro.vue